@if (showSpinner) {
  <app-loader></app-loader>
}
<main class="content-wrapper" [ngStyle]="{ background: selectedMode === 'dark' ? '#111526' : '' }">
  <div class="container-fluid mb-4">
    <div class="row" style="padding-top: 10px !important; padding-bottom: 20px !important">
      <div class="col-12 p-3 main-heading-section" [ngClass]="{ 'dark-text': selectedMode === 'dark' }">
        <h3 class="font-weight-bold">
          All Team {{model.month_char}}
        </h3>
        @if (currentUser_role === 'Team_Lead' || currentUser_role === 'Admin_AND_Team_Lead') {
          <button class="btn btn-primary" (click)="navigateToAllUsersEvaluation()"
            >
            Add All User Evaluation
          </button>
        }
      </div>
    </div>
    <div class="row mt-3">
      <div class="col-xl-12 col-sm-6 col-12">
        <!-- ------------ 2nd ---------     -->
        <div class="card-body container-fluid rounded-8 mb-2 "
          [ngClass]="{ 'dark-backround': selectedMode === 'dark' }">
          <div class="row ">
            <div class=" col-4">
              <input type="text" class="form-control" placeholder="Search by Name" [(ngModel)]="searchText"
                (keyup)="filterEvaluationsByName()">
              </div>
              <div class=" col-4">
                <input type="text" class="form-control" placeholder="Search by Designation"
                  [(ngModel)]="searchDesignation" (keyup)="filterEvaluationsByDesignation()">
                </div>
                <div class="filter-by-values  col-4">
                  <select [(ngModel)]="selectedOption" (change)="callFunction()">
                    <option [ngValue]="''" hidden [selected]="selectedOption === ''">Filter</option>
                    <option [ngValue]="'filterReset'">Filter reset</option>
                    <option [ngValue]="'TLPublish'">Team Lead Publish</option>
                    <option [ngValue]="'TLpending'">Team Lead Pending</option>
                    <option [ngValue]="'PMpending'">PM Pending</option>
                    <option [ngValue]="'PMadd'">UNPUBLISHED</option>
                    <option [ngValue]="'PMpublished'">PUBLISHED</option>
                  </select>
                </div>
              </div>


              <div class=" row mt-4">
                <div class="col-8">
                  <form #f="ngForm" (ngSubmit)="onSubmit(f)">
                    <div class="row">
                      <div class="col-6">
                        <input type="text" onfocus="(this.type='month')" onblur="(this.type= this.value ? 'month' : 'text')"
                          placeholder="Search by Month*" class="form-control" name="date" #date="ngModel" ngModel>
                        </div>
                        <div class="col-3">
                          <button type="button" class="btn reset" (click)="onReset(f)">Reset</button>
                        </div>
                        <div class="col-3">
                          <button type="submit" class="btn apply">Apply</button>
                        </div>
                      </div>
                    </form>

                  </div>
                </div>

              </div>
              <!-- end filter -->

              @for (item of evaluate; track item) {
                <div class="card shadow mb-2"
                  [ngClass]="{ 'dark-backround': selectedMode === 'dark', 'publish-card': item.employee_evaluation_current_month.is_evaluation === '1', 'TL-PM-Done-card': item.employee_evaluation_current_month.pm_points > '0' && item.employee_evaluation_current_month.points > '0' && item.employee_evaluation_current_month.is_evaluation === '0', 'pending-card': item.employee_evaluation_current_month == null, 'Only-TL-Done-card': item.employee_evaluation_current_month.points > '0' && item.employee_evaluation_current_month.pm_points == '0' }">
                  <div class="card-content rounded">
                    <!-- <a href=" " class="btn btn text-white   ml-2 mt-3 approved1">Approved</a> -->
                    <div class="card-body">
                      <div class="media d-flex text-center text-secondary salary">
                        @if (item.employee_evaluation_current_month.is_evaluation === '1') {
                          <div class="vertical-publish">
                            <span> PUBLISHED </span>
                          </div>
                        }
                        @if (item.employee_evaluation_current_month == null ) {
                          <div class="vertical-pending">
                            <span> PENDING </span>
                          </div>
                        }
                        @if (item.employee_evaluation_current_month.points > '0' && item.employee_evaluation_current_month.pm_points == '0') {
                          <div class="vertical-TL"
                            >
                            <span>PM PENDING </span>
                          </div>
                        }
                        <!-- <div class="vertical-TL1" *ngIf="item.employee_evaluation_current_month.points == '0' && item.employee_evaluation_current_month.pm_points > '0'">
                        <span>TL PENDING </span>
                      </div> -->
                      @if (item.employee_evaluation_current_month.pm_points > '0' && item.employee_evaluation_current_month.points > '0' && item.employee_evaluation_current_month.is_evaluation === '0') {
                        <div class="vertical-TL-PM"
                          >
                          <span> UNPUBLISHED</span>
                        </div>
                      }
                      <div class="col-4 mt-4">
                        <span>
                          <b style="font-size: 17px">{{item.first_name}}
                            &nbsp;
                          {{item.last_name}}</b></span>
                        </div>
                        <div class="col-3">
                          <span>Designation</span><br />&nbsp;
                          <h6>{{item.description}}</h6>
                        </div>
                        <div class="col-2">
                          <span>Rating</span><br />&nbsp;
                          <h6>
                            {{item.percentage || 'N/A'}}
                          </h6>
                        </div>
                        <div class="col-2">
                          <span>Band</span><br />&nbsp;
                          <h6> {{item.bands || 'N/A'}}</h6>
                        </div>
                        <div class="col-1 mt-1">
                          <a (click)="addEvaluation(item)" style="cursor: pointer;">
                          <img src="assets/aye_icon.svg" width="40px" alt="" /></a>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              }
              <!-- <app-loader *ngIf="showSpinner"> </app-loader> -->
            </div>


          </div>
        </div>
        <div class="mt-5" style="height: 404px"></div>
      </main>